export function camelCaseToSentence(text: string){
    let result = text.replace( /(\d*)([A-Z])/g, " $1 $2" );
    return result.charAt(0).toUpperCase() + result.slice(1);
}
